import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AccessToken} from '../_models/access-token.model';
import {Client} from '@microsoft/microsoft-graph-client';

@Injectable()
export class MicrosoftGraphService {

  get GraphClient(): Client {
      return this.GraphClientSubject.value;
  }

  public GraphClientSubject: BehaviorSubject<Client>;


  constructor() {
    // Paramétrage des observables
    this.GraphClientSubject = new BehaviorSubject<Client>(undefined);
  }

  init(accessToken: AccessToken) {
    if (accessToken) {
      this.GraphClientSubject.next(Client.init({
        authProvider: (done) => {
          done(null, accessToken.access_token);
        }}));
    }
  }
}
